import React, { useMemo, useCallback } from 'react';
import propTypes from 'prop-types';
import dayjs from 'dayjs-ext';
;
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { UiTable } from 'src/ui';
import { Button, MuiDropdown, MuiDropdownItem } from 'src/ui/mui-ui-kit';;

import { DATE_SMONTH_DAY_SYEAR } from 'src/ui/const';

export function ProductsTable({
  loading,
  products,
  onDeleteProduct,
  emptyOnClickButton,
  onEditProduct,
}) {
  const onDelete = useCallback(product => {
    return () => onDeleteProduct(product);
  }, []);
  const onEdit = useCallback(product => {
    return () => onEditProduct(product);
  });

  const tableColumns = useMemo(
    () => [
      {
        Header: 'Product Name',
        accessor: 'name',
        Cell: row => (
          // eslint-disable-next-line
          <a className="edit-link" onClick={onEdit(row.original)}>
            {row.value}
          </a>
        ),
      },
      {
        Header: 'Batch #',
        accessor: 'batchNumber',
      },
      {
        Header: 'Date Added',
        accessor: 'dateAdded',
        Cell: row => (
          <div>{dayjs(row.value).format(DATE_SMONTH_DAY_SYEAR)}</div>
        ),
      },
      {
        Header: '',
        accessor: 'id',
        sortable: false,
        width: 62,
        resizable: false,
        Cell: row => (
          <MuiDropdown
            isAlign="right"
            renderTrigger={
              <Button isColor="white">
                <span className="icon">
                  <FontAwesomeIcon
                    icon={['fal', 'ellipsis-v']}
                    className="has-text-grey"
                    size="lg"
                  />
                </span>
              </Button>
            }
          >
              <MuiDropdownItem tag="a" onClick={onEdit(row.original)}>
                Edit
              </MuiDropdownItem>
              <MuiDropdownItem tag="a" onClick={onDelete(row.original)}>
                Archive
              </MuiDropdownItem>
          </MuiDropdown>
        ),
      },
    ],
    []
  );

  const subComponent = row => {
    if (row.original.coas.length === 0) {
      return null;
    }

    return (
      <div
        className="rt-td has-text-grey-medium-dark"
        style={{ paddingBottom: '10px' }}
      >
        {row.original.coas.map((coa, idx) => (
          <div key={idx} style={{ display: 'block' }}>
            <div style={{ paddingLeft: '35px', display: 'table-cell' }}>
              <a href={coa.url} target="_blank" rel="noopener noreferrer">
                Certificate Of Authenticity #{coa.id}
              </a>
            </div>
          </div>
        ))}
      </div>
    );
  };

  return (
    <UiTable
      columns={tableColumns}
      loading={loading}
      data={products}
      resolveData={data => data}
      title="Product COA"
      emptyOnClickButton={emptyOnClickButton}
      SubComponent={subComponent}
      getTheadThProps={() => ({
        className: 'has-text-left',
      })}
      toPrev="/vendors"
      toNext="/documents"
      hideNext
      hidePrev
    />
  );
}

ProductsTable.propTypes = {
  loading: propTypes.bool.isRequired,
  products: propTypes.arrayOf(propTypes.object).isRequired,
  onDeleteProduct: propTypes.func.isRequired,
  emptyOnClickButton: propTypes.func.isRequired,
  onEditProduct: propTypes.func.isRequired,
};
